export enum AbsenceType {
	CHILD_CARE = "CHILD_CARE",
	LEAVE_OF_ABSENCE = "LEAVE_OF_ABSENCE",
	SICK_LEAVE = "SICK_LEAVE",
}
